var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownArrowSecondary = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "30px",
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/share") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L30,0 L30,30 L0,30 L0,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sign-Up/Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/share",
    transform: "translate(0.5, 0)",
    xlinkHref: "#path-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.99443,5 L16.4784884,6.42698574 L16.466,6.438 L21.6938797,11.4276345 C22.087868,11.8036605 22.1024294,12.4278805 21.7264034,12.8218689 C21.7166609,12.8320768 21.7067004,12.8420744 21.6965288,12.8518549 C21.281665,13.2507642 20.6261662,13.2519834 20.2098213,12.8546202 L16.043,8.878 L16.0435921,24.9487858 C16.0435921,25.5293554 15.5729475,26 14.9923779,26 C14.4118083,26 13.9411637,25.5293554 13.9411637,24.9487858 L13.941,8.848 L9.78934502,12.8111633 C9.37300018,13.2085265 8.71750131,13.2073072 8.30263757,12.8083979 C7.91005075,12.4309089 7.8978116,11.806639 8.27530066,11.4140522 C8.28508111,11.4038806 8.29507875,11.3939201 8.30528668,11.3841775 L14.99443,5 Z",
    id: "Combined-Shape",
    fill: "#1E2969",
    fillRule: "evenodd",
    transform: "translate(14.9996, 15.5) rotate(-180) translate(-14.9996, -15.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownArrowSecondary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/down-arrow-secondary.5f74e380ef56e8c25b1e88f81abe07f1.svg";